<template>
     <div style="width:1300px;margin:0 auto;">
         <button class="btn btn-primary" style="margin-left:-60px;margin-top:30px;" @click.prevent="$router.go(-1)">返回</button>
            <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:40px;">
                <p class="text-center mb-2">
                     <span style="font-size:15px;">
                       添加帖子
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
                                     <p class="mb-2" style="font-size:15px;">
                                         <span>
                                             标题:
                                         </span>
                                         <input type="text" class="input_form-control" v-model="title">
                                         <!-- <span style="color:red;">
                                               (此日期为论坛添加日期，可修改，请勿删除!)
                                         </span> -->
                                         <!-- <span>
                                             作者：
                                         </span>
                                         <input type="text" class="input_form-control" v-model="author"> -->
                                     </p>
                                     <div>
                                            <quill-editor ref="myTextEditor" v-model="content" :options="editorOption" style="height:400px;">
                                            </quill-editor>
                                     </div>
                                     <table></table>
                                     <div class="mt-5">
                                        <span style="font-size:15px;">
                                            添加图片:
                                        </span>
                                     </div>
                                     <!-- <div class="tu_box">
                                          <div class="m-1 del" v-for="(item,i) in imgsback" :key='i'>
                                              <img class="kuang_tu" :src="item" >
                                          </div>
                                        <div class="kuang m-1">
                                              <img @click="fileBtn()" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                              <input style="display:none"  @change="tirggerFile($event)" type="file" id="file">
                                        </div>
                                     </div> -->
                                        <div class="form-group">
                                          <!-- <label class="control-label">上传图片</label> -->
                                          <div class="control-form">
                                            <p class="help-block">(建议图片格式为：JPEG/BMP/PNG/GIF，大小不超过5M，最多可上传5张)</p>
                                            <ul class="upload-imgs">
                                              <li v-for='(value, index) in imgdata' :key="index">
                                                <p class="img"><img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+value"><a class="close" @click="delImg(index)">×</a></p>
                                              </li>
                                              <li v-if="imgdata.length>=5 ? false : true">
                                                <input style="display:none" type="file" id="file" class="upload" @change="addImg()" ref="inputer" multiple accept="image/png,image/jpeg,image/gif,image/jpg"/>
                                                <!-- <a class="add"><i class="iconfont icon-plus"></i><p>点击上传</p></a> -->
                                                <img @click="fileBtn()" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <!-- <div>
                                                   <input style="display:none" type="file" id="file" class="upload" @change="addImg()" ref="inputer" multiple accept="image/png,image/jpeg,image/gif,image/jpg"/>
                                                            <p>

                                                                 <img v-for="item in imgdata" :key='item' style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+item" alt="">
                                                            </p>
                                                   <img @click="fileBtn()" class="box-img" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                        </div> -->
                                        <!-- <p>
                                            <button @click="submit()" class="btn btn-primary">
                                              上传图片
                                            </button>
                                        </p> -->

                                        <div>
                                            <span style="font-size:15px;">
                                                上传文件:
                                            </span>
                                        </div>
                                         <div class="form-group">
                                          <!-- <label class="control-label">上传图片</label> -->
                                          <div class="control-form">
                                            <p class="help-block">(建议文件格式为:doc, xls, ppt, pdf, docx, xlsx, pptx,最多可以上传十个文件)</p>
                                            <ul class="upload-imgs">
                                              <li v-for='(value, index) in wendata' :key="index">
                                                <p class="wen">
                                                   <span style="color:red;">附件</span>
                                                   <span style="color:red;">{{index+1}}</span>
                                                  <a class="close" @click="delImg1(index)">×</a></p>
                                                  <span style="color:blue;">
                                                    {{value | handler}}
                                                  </span>
                                              </li>
                                              <li v-if="wendata.length>=10 ? false : true">
                                                <input style="display:none" type="file" id="file1" class="upload" @change="addImg1()" ref="inputer" multiple accept=".doc,.xls,.ppt,.docx,.xlsx,.pptx"/>
                                                <!-- <a class="add"><i class="iconfont icon-plus"></i><p>点击上传</p></a> -->
                                                <img @click="fileBtn1()" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      <p class="text-center mt-1">
                                                <button class="btn btn-primary" @click="modificationBlog()">添加</button>
                                      </p>
            </div> 
     </div>
</template>
<script>
// import { addQuillTitle } from '../../components/common/quill-title.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import {mapState,mapMutations} from 'vuex'

export default {
     data(){
          return{
              BlogList:[],
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              content: '',
              editorOption: {
              placeholder: '添加帖子内容',
               modules:{
                        toolbar:[
                           ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                        ]
                    }
             },

             title:'',
             author:'',
            //  getMonth1:'',
            currentTime:'',
            // imgUrl:'',
            // imgsback: [],      // 图片预览地址
            //   imgfilesback: [],  // 图片原文件，上传到后台的数据
            //   sizeback: 1 ,      // 限制上传数量
            imgdata:[],
            imgdata1:[],
            imgs:"",
            

            wendata:[],
            wendata1:[],
            wens:"",

          }
      },
        components: {
             quillEditor
        },
        filters:{
           handler(value){
             let wenjian=value.split("/")
            return wenjian[wenjian.length-1]
             
          },
        },

      methods:{
          ...mapMutations([
                 'IMG_URL'
          ]),

         

//           handleFileChange (e) {
// 　　　　let inputDOM = this.$refs.inputer;
// 　　　　this.file = inputDOM.files[0];// 通过DOM取文件数据
// 　　　　let size = Math.floor(this.file.size / 1024);//计算文件的大小　
// 　　　　this.formData=new FormData();//new一个formData事件
// 　　　　this.formData.append("file",this.file); //将file属性添加到formData里
// 　　　　//此时formData就是我们要向后台传的参数了
// 　　},
        //上传图片 预览 删除
      //   addImg(event){
      //   let inputDOM = this.$refs.inputer;
      //   // 通过DOM取文件数据
      //   this.fil = inputDOM.files;
      //   let oldLen=this.imgLen;
      //   let len=this.fil.length+oldLen;
      //   if(len>5){
      //     alert('最多可上传5张，您还可以上传'+(5-oldLen)+'张');
      //     return false;
      //   }
      //   for (let i=0; i < this.fil.length; i++) {
      //     let size = Math.floor(this.fil[i].size / 1024);
      //     if (size > 5*1024*1024) {
      //       alert('请选择5M以内的图片！');
      //       return false
      //     }
      //     this.imgLen++;
      //     this.$set(this.imgs,this.fil[i].name+'?'+new Date().getTime()+i,this.fil[i]);
      //   }
      // },
      // getObjectURL(file) {
      //   var url = null ;
      //   if (window.createObjectURL!=undefined) { // basic
      //     url = window.createObjectURL(file);
      //   } else if (window.URL!=undefined) { // mozilla(firefox)
      //     url = window.URL.createObjectURL(file) ;
      //   } else if (window.webkitURL!=undefined) { // webkit or chrome
      //     url = window.webkitURL.createObjectURL(file) ;
      //   }
      //   return url ;
      // },
      //删除
       delImg1(index){
        this.wendata.splice(index,1);
        //  console.log(this.imgdata);
      },

      delImg(index){
        this.imgdata.splice(index,1);
        //  console.log(this.imgdata);
      },
  //上传文件
      async addImg1(){
          let that=this;
          let file = event.target.files[0]; //获取input的图片file值
          // console.log(file)
          let param = new FormData(); // 创建form对象
          
          param.append("imgFile", file);
          param.append("username",window.sessionStorage.getItem('username')); 
          param.append("tokenid",window.sessionStorage.getItem('tokenid')); 
          param.append("phone_uuid","");
          await that.$http.post('Dls/UpLoadFile', param).then(res => {
               that.alertShow=true;
              // console.log(res)
            if(res.data.isok){
              that.IMG_URL(res.data.data);
              if(that.wendata.length<=10){
              that.wendata.push(res.data.data);
              console.log(that.wendata)
              that.$message.success("操作成功!")
            }
            else{
              alert("最多只能传入十个文件")
            }
            }
            else{
              alert(res.data.message)
            }
        });
      },
      //上传日志图片
      async addImg(){
          let that=this;
          let file = event.target.files[0]; //获取input的图片file值
          let param = new FormData(); // 创建form对象
          param.append("imgFile", file);
          param.append("username",window.sessionStorage.getItem('username')); 
          param.append("tokenid",window.sessionStorage.getItem('tokenid')); 
          param.append("phone_uuid","");
          await that.$http.post('Dls/UpLoadImage', param).then(res => {
              that.alertShow=true;
            if(res.data.isok){
              // console.log(res)
              that.IMG_URL(res.data.data);
              if(that.imgdata.length<=4){
              that.imgdata.push(res.data.data);
              that.$message.success("操作成功!")
            }
            else{
              alert("最多只能传入五张图片")
            }
            }
            else{
              alert(res.data.message)
            }
        });
      },
        //上传图片
          fileBtn(){
          document.getElementById('file').click();
          let file = document.getElementById('file');
            //  console.log(file.value);
       },
         fileBtn1(){
          document.getElementById('file1').click();
          let file = document.getElementById('file1');
            //  console.log(file.value);
       },
      //预览图片
    //   tirggerFile: function(e) {
    //             const that = this
    //             let event = event || window.event;
    //             let file = event.target.files
    //             let leng=file.length;
    //             for(var i=0;i<leng;i++){
    //                 let reader = new FileReader();    // 使用 FileReader 来获取图片路径及预览效果
    //                 that.imgfilesback.push(file[i])
    //                 reader.readAsDataURL(file[i]); 
    //                 reader.onload =function(e){
    //                 that.imgsback.push(e.target.result);   // base 64 图片地址形成预览                                 
    //                 };                 
    //   };
    // },
    getNowTime() {
		let date = new Date();
    this.year = date.getFullYear();
    this.getMonth1=date.getMonth() + 1
		this.month = date.getMonth() + 1 < 10 ? "0" + this.getMonth1 : date.getMonth() + 1;
		this.date = date.getDate();
		this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
		this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
		this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		this.milliSeconds = date.getMilliseconds();
		let currentTime = this.year+'-'+this.month + '-' + this.date;
        // console.log(currentTime);
        this.title=currentTime;
	},
       onEditorChange({ editor, html, text }) {
            this.content = html;
        }, 
        //添加帖子
       modificationBlog:async function(){
         const that = this
              that.imgdata1=[...that.imgdata]
              if(that.imgdata1.length<5){
                
                    for(let i=0;i<9-that.imgdata1.length;i++){
                           that.imgdata1.push("")
                    }
              }
            that.imgs=that.imgdata1.toString()
             that.wendata1=[...that.wendata]
              if(that.wendata1.length<10){
                
                    for(let i=0;i<19-that.wendata1.length;i++){
                           that.wendata1.push("")
                    }
              }
            that.wens=that.wendata1.toString()
            // console.log(that.wens);
            if(that.title.trim()==""||that.content.trim()==""){
                alert("标题或内容不能为空！")
            }else{
                            const { data: res } = await that.$http.post('Dls/getFun', {
                    action: 'ClerkUpBlog',
                    obj: JSON.stringify({
                            // username:'kzy001',
                            lxs:'0',
                            lx:"4",
                            state:'0',
                            contents:that.content,
                            // id:'',
                            title:that.title,
                            // reply:'',
                            img:that.imgs,
                            file:that.wens,
                    })
                    })
                     console.log(res)
                    if (res.isok) {
                        if(res.data.isok){
                            that.$message.success(res.data.msg)
                        that.$router.go(-1)
                        const obj = res.data;
                        }
                        else{
                            alert(res.data.msg)
                        }
                    }
            }
          
       },
      },
      mounted(){
        //  addQuillTitle(); 
      },
      created(){
        //   this.getNowTime();
      }

}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
.input_form-control { 
// display: block; 
width: 20%; 
height: 34px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
} 
.kuang{
  width:100px;
  height:100px;
  border: 1.4px dashed #ccc;
}
.kuang:hover{
  width:100px;
  height:100px;
  border: 1.4px dashed #000;
}
.kuang_tu{
  width:100px;
  height:100px;
}
.tu_box{
   display:flex;
}
.del{
  border:1.4px dashed #ccc;
}

.upload-imgs{
  margin: 5px 0 10px 0;
  overflow: hidden;
  font-size: 0;
  }

.upload-imgs li{
  position: relative;
  width: 109px;
  height: 109px;
  font-size: 14px;
  display: inline-block;
  padding: 3px;
  margin-right: 10px;
  border: 1.4px dashed #ccc;
  text-align: center;
  vertical-align: middle;}
.upload-imgs li:hover{
    border: 1.4px dashed #36d;
  }
.upload-imgs .add{
  display: block;
  background-color: #ccc;
  color: #ffffff;
  height: 94px;
  padding: 8px 0;
  }
.upload-imgs .add .iconfont{padding: 10px 0;font-size: 40px;}
.upload-imgs li:hover .add{background-color: "#36d";}
.upload-imgs li .upload{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 109px;
  height: 109px;}
.upload-imgs .img{
  position: relative;
  width: 94px;height: 94px;line-height: 94px;}
  .upload-imgs .wen{
  position: relative;
  width: 98px;height: 50px;line-height: 50px;}
.upload-imgs .img img{vertical-align: middle;}
.upload-imgs .img .close{display: none;}
.upload-imgs li:hover .img .close{display: block;position: absolute;right: -6px;top: -10px;line-height: 1;font-size: 22px;color: #36d;}
.box-img{
    border:1.4px dashed #ccc;
}
.box-img:hover{
  border:1.4px dashed #36d;
}
</style>




// WEBPACK FOOTER //
// src/pages/Forum/AddForum.vue